// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import { EPISODE, SERIESSUBDATA } from "../../../utility/constants";
import axios from "axios";
import {
  FETCH_EPISODE_REQUEST,
  fetchEpisodeSuccess,
  fetchEpisodeFailure,
} from "../../actions/episodeActions";

function* fecthEpisode(action) {
  try {
    const episodeFormdata = new FormData();
    // episodeFormdata.append("entryid", action.payload.entryid);
    episodeFormdata.append("categoryid", action.payload.catId);

    // const response = yield call(axios.post, EPISODE, episodeFormdata, {

    const response = yield call(axios.post, SERIESSUBDATA, episodeFormdata, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    if (response.status === 200 && response.data.status === "Success") {
      
      yield put(fetchEpisodeSuccess(response.data));
    }
  } catch (error) {
    yield put(fetchEpisodeFailure(error.message));
  }
}

export function* EpisodeSaga() {
  yield takeLatest(FETCH_EPISODE_REQUEST, fecthEpisode);
}
export default EpisodeSaga;
